import { Injectable, ApplicationRef, Inject, forwardRef, Injector } from '@angular/core';

import { BaseService } from './base.service';
import { PopupService } from './popup.service';
import { UserService } from './user.service';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { environment } from '../../environments/environment';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class MapService {
  boundsListener: any;
  idleListener: any;
  currentUserMap: any;
  userMaps: any = {
    allMaps: [],
    received: [],
    shared: [],
    deleted: []
  };
  isMapReceived: boolean = false;
  recordsPerPage: number = 10;
  searchValue: string = '';
  deletedSearchValue: string = '';
  mapResizeInterval: any;
  showDemographicReport: boolean = false;
  selectedDemoPointData: any = null;

  mapLoadedChangeSubscription: Subscription;
  shareMapChangeSource = new BehaviorSubject<boolean>(false);
  shareMapChangeStream = this.shareMapChangeSource.asObservable();

  saveMapChangeSource = new BehaviorSubject<boolean>(false);
  saveMapChangeStream = this.saveMapChangeSource.asObservable();

  public userService: any;

  constructor(public baseService: BaseService, public appRef: ApplicationRef, public injector: Injector,
    public httpClient: HttpClient, public popupService: PopupService, public router: Router) {
    }

  initializeMapLoadSubscription() {
    this.mapLoadedChangeSubscription = this.baseService.mapLoadedChangeStream.subscribe((value)=>{
      if(value) {
        this.baseService.addBrowserAndDeviceSettings();
      }
    });
  }

  addMapResizeInterval() {
    let w = (<any>window);
    this.mapResizeInterval = setInterval(()=>{
      w.google.maps && w.map && w.google.maps.event.trigger(w.map, 'resize');
    }, 1000);
  }

  getSingleUserMap(id) {
    return this.userMaps.allMaps.find((obj, index)=>{
      obj.index = index;
      return obj.id === id;
    });
  }

  saveMap(map) {
    const headers = { 'Content-Type': 'application/json' };

    return this.httpClient.post(
      environment.APP.API_URL + '/map',
      JSON.stringify(map),
      { headers }
    )
    .map((res) => {
      return res;
    });
  }

  getSingleMapApiCall(accessId) {
    return this.httpClient.get(environment.APP.API_URL + '/map/' + accessId)
    .map((res) => {
      return res;
    });
  }

  updateMap(map) {
    const headers = { 'Content-Type': 'application/json' };

    return this.httpClient.put(
        environment.APP.API_URL + '/map/'+map.id,
        JSON.stringify(map),
        { headers }
      )
      .map((res) => {
        return res;
      });
  }

  getAllMaps(params) {
    return this.httpClient.get(
      environment.APP.API_URL + '/map?recordsPerPage='+this.recordsPerPage+
      '&pageNumber='+params.pageNumber+'&'+params.filter+'=true&name='
      +(params.filter === 'deleted'? encodeURIComponent(this.deletedSearchValue): encodeURIComponent(this.searchValue))
    )
    .map((res) => {
      return res;
    });
  }

  deleteMap(mapId) {
    return this.httpClient.delete(
      environment.APP.API_URL + '/map/'+ mapId
    )
    .map((res) => {
      return res;
    });
  }

  shareMap(data) {
    const headers = { 'Content-Type': 'application/json' };

    return this.httpClient.post(
        environment.APP.API_URL + '/map/share',
        JSON.stringify(data),
        { headers }
      )
      .map((res) => {
        return res;
      });
  }

  checkIfMapIsReceived(isReceived) {
    this.isMapReceived = isReceived;
    if(isReceived) {
      (<any>window).domBody.classList.remove('user-map');
      (<any>window).domBody.classList.add('received-map');
    } else {
      (<any>window).domBody.classList.remove('received-map');
      (<any>window).domBody.classList.add('user-map');
    }
  }

  closeUserCurrentMap() {
    let w = (<any>window);
    w.localStorageHandler.removeMapAccessIdFromLS();
    this.router.navigate(['/map'],{replaceUrl:true})
    this.currentUserMap = null;
    delete w.mapData.accessKey;
    if(this.isMapReceived) {
      w.Events.publish('resetToUserBrand');
      w.saveMap.resetData();
    }
    w.saveMap.load(w.saveMap.previousUnsaved, true);
    this.checkIfMapIsReceived(false);
    this.shareMapChangeSource.next(false);
    this.saveMapChangeSource.next(false);
    w.notifyChange = this.currentUserMap ? true : false;
    w.domBody.classList.remove('user-map');
    w.Events.publish('detectChanges');
  }

  closeIfMapActive(id) {
    this.currentUserMap && (this.currentUserMap.id === id) && this.closeUserCurrentMap();
  }

  getLocationPredictions(query ,currentLocation) {
    return this.httpClient.get(
      environment.APP.API_URL + '/search?query=' + encodeURIComponent(query) +
      '&lat='+ encodeURIComponent(currentLocation.lat) +
      '&lng='+ encodeURIComponent(currentLocation.lng)
    )
    .map((res) => {
      return res;
    });
  }

  getDemographicReport(requestBody) {
    const headers = { 'Content-Type': 'application/json' };
    var url = environment.APP.API_URL + '/demographic/report/create';
    if(this.isUserAgentIos()) {
      url += "/mobile";
      return this.httpClient.post(url,
        JSON.stringify(requestBody),
        { headers }
      )
        .map((res) => {
          return res;
        });
    }
    return this.httpClient.post(url,
      JSON.stringify(requestBody),
      { headers , responseType : 'blob' }
    )
    .map((res) => {
      return res;
    });
  }

  isUserAgentIos() {
    let w = (<any>window);
    return (w.navigator.userAgent.indexOf('CriOS') >= 0 || w.navigator.userAgent.indexOf('iPad') >= 0 || w.navigator.userAgent.indexOf('iPhone') >= 0);
  }

  ngOnDestroy() {
    this.mapLoadedChangeSubscription && this.mapLoadedChangeSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/services/map.service.ts